/* Good Travel · Presupuesto: prefijo con bandera, país escrito y email comprobado */
(function () {
'use strict';
var root = document.getElementById('gtq');
if (!root || root.dataset.contacto) return;
root.dataset.contacto = '1';
var form = root.querySelector('form');
if (!form || root.querySelector('[data-done]')) return;

/* País (como se escribe en español) · código ISO · prefijo */
var P = ('España|ES|34;Venezuela|VE|58;Colombia|CO|57;Panamá|PA|507;Estados Unidos|US|1;República Dominicana|DO|1;México|MX|52;Perú|PE|51;Ecuador|EC|593;Argentina|AR|54;Chile|CL|56;' +
'Portugal|PT|351;Reino Unido|GB|44;Francia|FR|33;Italia|IT|39;Alemania|DE|49;Afganistán|AF|93;Albania|AL|355;Andorra|AD|376;Angola|AO|244;Antigua y Barbuda|AG|1;Arabia Saudí|SA|966;Argelia|DZ|213;' +
'Armenia|AM|374;Aruba|AW|297;Australia|AU|61;Austria|AT|43;Azerbaiyán|AZ|994;Bahamas|BS|1;Bangladés|BD|880;Barbados|BB|1;Baréin|BH|973;Bélgica|BE|32;Belice|BZ|501;Benín|BJ|229;Bielorrusia|BY|375;' +
'Bolivia|BO|591;Bosnia y Herzegovina|BA|387;Botsuana|BW|267;Brasil|BR|55;Brunéi|BN|673;Bulgaria|BG|359;Burkina Faso|BF|226;Burundi|BI|257;Bután|BT|975;Cabo Verde|CV|238;Camboya|KH|855;Camerún|CM|237;' +
'Canadá|CA|1;Catar|QA|974;Chad|TD|235;China|CN|86;Chipre|CY|357;Comoras|KM|269;Congo|CG|242;Corea del Sur|KR|82;Costa de Marfil|CI|225;Costa Rica|CR|506;Croacia|HR|385;Curazao|CW|599;Dinamarca|DK|45;' +
'Dominica|DM|1;Egipto|EG|20;El Salvador|SV|503;Emiratos Árabes Unidos|AE|971;Eritrea|ER|291;Eslovaquia|SK|421;Eslovenia|SI|386;Estonia|EE|372;Esuatini|SZ|268;Etiopía|ET|251;Filipinas|PH|63;Finlandia|FI|358;' +
'Fiyi|FJ|679;Gabón|GA|241;Gambia|GM|220;Georgia|GE|995;Ghana|GH|233;Granada|GD|1;Grecia|GR|30;Guatemala|GT|502;Guinea|GN|224;Guinea Ecuatorial|GQ|240;Guinea-Bisáu|GW|245;Guyana|GY|592;Haití|HT|509;' +
'Honduras|HN|504;Hong Kong|HK|852;Hungría|HU|36;India|IN|91;Indonesia|ID|62;Irak|IQ|964;Irlanda|IE|353;Islandia|IS|354;Israel|IL|972;Jamaica|JM|1;Japón|JP|81;Jordania|JO|962;Kazajistán|KZ|7;Kenia|KE|254;' +
'Kirguistán|KG|996;Kosovo|XK|383;Kuwait|KW|965;Laos|LA|856;Lesoto|LS|266;Letonia|LV|371;Líbano|LB|961;Liberia|LR|231;Libia|LY|218;Liechtenstein|LI|423;Lituania|LT|370;Luxemburgo|LU|352;Macao|MO|853;' +
'Macedonia del Norte|MK|389;Madagascar|MG|261;Malasia|MY|60;Malaui|MW|265;Maldivas|MV|960;Malí|ML|223;Malta|MT|356;Marruecos|MA|212;Mauricio|MU|230;Mauritania|MR|222;Moldavia|MD|373;Mónaco|MC|377;' +
'Mongolia|MN|976;Montenegro|ME|382;Mozambique|MZ|258;Myanmar|MM|95;Namibia|NA|264;Nepal|NP|977;Nicaragua|NI|505;Níger|NE|227;Nigeria|NG|234;Noruega|NO|47;Nueva Zelanda|NZ|64;Omán|OM|968;Países Bajos|NL|31;' +
'Pakistán|PK|92;Palestina|PS|970;Papúa Nueva Guinea|PG|675;Paraguay|PY|595;Polinesia Francesa|PF|689;Polonia|PL|48;Puerto Rico|PR|1;República Centroafricana|CF|236;República Checa|CZ|420;' +
'República Democrática del Congo|CD|243;Ruanda|RW|250;Rumanía|RO|40;Rusia|RU|7;Samoa|WS|685;San Marino|SM|378;Santa Lucía|LC|1;Senegal|SN|221;Serbia|RS|381;Seychelles|SC|248;Sierra Leona|SL|232;' +
'Singapur|SG|65;Somalia|SO|252;Sri Lanka|LK|94;Sudáfrica|ZA|27;Sudán|SD|249;Suecia|SE|46;Suiza|CH|41;Surinam|SR|597;Tailandia|TH|66;Taiwán|TW|886;Tanzania|TZ|255;Tayikistán|TJ|992;Timor Oriental|TL|670;' +
'Togo|TG|228;Trinidad y Tobago|TT|1;Túnez|TN|216;Turkmenistán|TM|993;Turquía|TR|90;Ucrania|UA|380;Uganda|UG|256;Uruguay|UY|598;Uzbekistán|UZ|998;Vietnam|VN|84;Yemen|YE|967;Yibuti|DJ|253;Zambia|ZM|260;Zimbabue|ZW|263')
  .split(';').map(function (r) { var a = r.split('|'); return { n: a[0], iso: a[1], d: a[2] }; });

/* Prefijos que comparten varios países: cuál se muestra por defecto */
var PRINCIPAL = { '1': 'US', '7': 'RU', '44': 'GB' };
/* Dentro del +1, el código de área dice el país */
var AREA1 = { '809': 'DO', '829': 'DO', '849': 'DO', '787': 'PR', '939': 'PR', '876': 'JM', '868': 'TT', '242': 'BS', '246': 'BB', '268': 'AG', '473': 'GD', '758': 'LC', '767': 'DM' };

function bandera(iso) {
  if (!iso || iso.length !== 2 || iso === 'XK') return iso === 'XK' ? '🇽🇰' : '🌐';
  return String.fromCodePoint(0x1F1E6 + iso.charCodeAt(0) - 65, 0x1F1E6 + iso.charCodeAt(1) - 65);
}
function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
function porIso(iso) { for (var i = 0; i < P.length; i++) if (P[i].iso === iso) return P[i]; return null; }
function porNombre(n) { var k = norm(n); for (var i = 0; i < P.length; i++) if (norm(P[i].n) === k) return P[i]; return null; }

var pre = root.querySelector('[data-pre]'), flag = root.querySelector('[data-flag]');
var pais = root.querySelector('[data-pais]');
var preTocado = false, paisTocado = false;

/* Listas de sugerencias */
function llenar(id, items) {
  var dl = document.getElementById(id); if (!dl) return;
  var f = document.createDocumentFragment();
  items.forEach(function (t) { var o = document.createElement('option'); o.value = t[0]; if (t[1]) o.label = t[1]; f.appendChild(o); });
  dl.appendChild(f);
}
var vistos = {};
llenar('gtq-pre-list', P.filter(function (p) { if (vistos[p.d]) return false; vistos[p.d] = 1; return true; })
  .map(function (p) { return ['+' + p.d, bandera(PRINCIPAL[p.d] || p.iso) + ' ' + (PRINCIPAL[p.d] ? porIso(PRINCIPAL[p.d]).n : p.n)]; }));
llenar('gtq-pais-list', P.slice().sort(function (a, b) { return a.n.localeCompare(b.n, 'es'); }).map(function (p) { return [p.n]; }));

/* País que corresponde a lo escrito en el prefijo */
function paisDelPrefijo(v) {
  var dig = String(v || '').replace(/\D/g, '');
  if (!dig) return null;
  if (dig.charAt(0) === '1') {
    var area = AREA1[dig.slice(1, 4)];
    if (area) return porIso(area);
    var elegido = porNombre(pais && pais.value);
    if (elegido && elegido.d === '1') return elegido;
    return porIso('US');
  }
  var actual = porNombre(pais && pais.value);
  for (var len = Math.min(4, dig.length); len > 0; len--) {
    var cod = dig.slice(0, len);
    var cand = P.filter(function (p) { return p.d === cod; });
    if (!cand.length) continue;
    if (actual && actual.d === cod) return actual;
    return PRINCIPAL[cod] ? porIso(PRINCIPAL[cod]) : cand[0];
  }
  return null;
}
function pintarBandera() {
  if (!flag || !pre) return;
  var p = paisDelPrefijo(pre.value), k = p ? p.iso.toLowerCase() : '';
  if (flag.dataset.iso !== k) { flag.dataset.iso = k; flag.innerHTML = k ? '<img src="https://flagcdn.com/w40/' + k + '.png" alt="" width="22" height="16">' : '🌐'; }
  flag.title = p ? p.n : '';
  return p;
}
if (pre) {
  pre.addEventListener('input', function () {
    preTocado = true;
    var v = pre.value.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
    if (v && v.charAt(0) !== '+') v = '+' + v;
    if (v !== pre.value) pre.value = v;
    var p = pintarBandera();
    if (p && pais && !paisTocado && pre.value.replace(/\D/g, '').length >= 1) { pais.value = p.n; marcar(pais, false); }
    marcar(pre, false);
  });
  pre.addEventListener('blur', function () { if (pre.value === '+') pre.value = ''; pintarBandera(); });
}
if (pais) {
  pais.addEventListener('input', function () {
    paisTocado = true;
    var p = porNombre(pais.value);
    if (p && pre && (!preTocado || !pre.value)) { pre.value = '+' + p.d; }
    pintarBandera();
  });
}
pintarBandera();

/* Email: formato completo, errores típicos y si es personal o de empresa */
var mail = root.querySelector('#gtq-mail'), hint = root.querySelector('[data-mail-hint]');
var PERSONALES = /^(gmail\.com|googlemail\.com|hotmail\.(com|es|co\.uk|fr|it)|outlook\.(com|es)|live\.(com|es)|msn\.com|yahoo\.(com|es|co\.uk|fr)|ymail\.com|icloud\.com|me\.com|mac\.com|aol\.com|protonmail\.com|proton\.me|gmx\.(com|es|de)|zoho\.com|telefonica\.net|movistar\.es)$/;
var ERRATAS = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gamil.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com', 'gmail.comm': 'gmail.com', 'gmail.es': 'gmail.com', 'gmail.cpm': 'gmail.com', 'gmail.vom': 'gmail.com',
  'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmil.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'hotmail.cm': 'hotmail.com', 'hormail.com': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.con': 'outlook.com', 'outlook.co': 'outlook.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahoo.co': 'yahoo.com',
  'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com', 'icloud.con': 'icloud.com', 'live.con': 'live.com'
};
var SIN_PUNTO = { gmail: 'gmail.com', hotmail: 'hotmail.com', outlook: 'outlook.com', yahoo: 'yahoo.com', icloud: 'icloud.com', live: 'live.com' };
function revisaMail(v) {
  v = String(v || '').trim().toLowerCase();
  if (!v) return { ok: false, msg: '' };
  var at = v.lastIndexOf('@');
  if (at < 1 || v.indexOf(' ') > -1) return { ok: false, msg: 'Escribe tu email completo, por ejemplo nombre@gmail.com' };
  var user = v.slice(0, at), dom = v.slice(at + 1);
  if (SIN_PUNTO[dom]) return { ok: false, msg: 'Falta el final del email.', sug: user + '@' + SIN_PUNTO[dom] };
  if (ERRATAS[dom]) return { ok: false, msg: 'Parece que hay un error en el email.', sug: user + '@' + ERRATAS[dom] };
  if (!/^[a-z0-9._%+\-]+$/.test(user) || !/^([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,24}$/.test(dom)) return { ok: false, msg: 'El email no está completo. Revisa que termine en .com, .es u otra terminación.' };
  return { ok: true, tipo: PERSONALES.test(dom) ? 'personal' : 'empresa', dom: dom };
}
function pintarMail(final) {
  if (!mail || !hint) return true;
  var r = revisaMail(mail.value);
  var firma = mail.value + '|' + !!final;
  if (hint.dataset.firma === firma && !hint.hidden) { if (final) marcar(mail, !r.ok); return r.ok; }
  hint.dataset.firma = firma;
  hint.innerHTML = '';
  hint.className = 'q-mail-hint';
  if (!mail.value.trim()) { hint.hidden = true; return false; }
  if (r.ok) {
    hint.hidden = false;
    hint.classList.add('is-ok');
    hint.textContent = r.tipo === 'personal' ? '✓ Correo personal' : '✓ Correo de empresa · ' + r.dom;
    marcar(mail, false);
    return true;
  }
  if (!final && !r.sug && mail.value.indexOf('@') === -1) { hint.hidden = true; return false; }
  hint.hidden = false;
  hint.classList.add('is-bad');
  hint.appendChild(document.createTextNode(r.msg + ' '));
  if (r.sug) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = '¿Querías decir ' + r.sug + '?';
    b.addEventListener('mousedown', function (e) { e.preventDefault(); });
    b.addEventListener('click', function () { mail.value = r.sug; mail.dispatchEvent(new Event('input', { bubbles: true })); pintarMail(true); });
    hint.appendChild(b);
  }
  if (final) marcar(mail, true);
  return false;
}
if (mail) {
  var t;
  mail.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { pintarMail(false); }, 400); });
  mail.addEventListener('blur', function () { pintarMail(true); });
  if (mail.value) pintarMail(false);
}

function marcar(el, bad) { var w = el && el.closest('.q-fl'); if (w) w.classList.toggle('q-bad', !!bad); }

/* Antes de enviar: email correcto, prefijo y país con sentido */
function gate(e) {
  var info = root.querySelector('[data-foot-info]');
  var malos = [];
  if (mail && !pintarMail(true)) malos.push([mail, 'Revisa tu email']);
  if (pre && pre.value.replace(/\D/g, '').length < 1) { marcar(pre, true); malos.push([pre, 'Escribe el prefijo de tu teléfono, por ejemplo +34']); }
  if (pais && pais.value.trim().length < 2) { marcar(pais, true); malos.push([pais, 'Escribe tu país']); }
  if (!malos.length) { if (pre && pre.value.charAt(0) !== '+') pre.value = '+' + pre.value.replace(/\D/g, ''); return; }
  e.preventDefault(); e.stopImmediatePropagation();
  malos[0][0].focus();
  if (info) info.textContent = malos[0][1];
}
root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-submit]')) gate(e); }, true);
root.addEventListener('submit', function (e) { if (e.target === form) gate(e); }, true);
})();
